import { Link } from "react-router-dom";
import { POSTS } from "@/data/blogPosts";
import { useSeo, SITE_URL } from "@/lib/seo";
import { ArrowRight, Clock } from "lucide-react";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "Blog",
  name: "InspectorProLeads Blog",
  url: `${SITE_URL}/blog`,
  description: "Local guides for Sacramento and Placer County home-service pros and homeowners.",
  blogPost: POSTS.map((p) => ({ "@type": "BlogPosting", headline: p.title, url: `${SITE_URL}/blog/${p.slug}`, datePublished: p.date })),
};

export default function Blog() {
  useSeo({
    title: "Blog: Local Lead & Home-Service Guides for Sacramento | InspectorProLeads",
    description: "Practical guides for Sacramento and Roseville home inspectors, pest control, roofing and HVAC pros, plus tips for local homeowners.",
    path: "/blog",
    jsonLd,
  });
  return (
    <div className="container-x py-14" data-testid="blog-page">
      <div className="max-w-2xl mb-12">
        <span className="text-xs font-mono uppercase tracking-wider text-[color:var(--emerald)]">Blog & Guides</span>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-[color:var(--navy)] mt-2">Real talk for local pros & homeowners</h1>
        <p className="text-[color:var(--ink-2)] mt-4">Straightforward guides on winning more jobs in Sacramento & Placer County, and on hiring the right pro for your home.</p>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        {POSTS.map((p) => (
          <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}
            className="card-soft p-8 group hover:-translate-y-1 transition-transform duration-300">
            <span className="text-xs font-mono uppercase tracking-wider badge-pest px-3 py-1 rounded-full">{p.tag}</span>
            <h2 className="font-display text-2xl font-bold text-[color:var(--navy)] mt-4 group-hover:text-[color:var(--emerald)] transition-colors">{p.title}</h2>
            <p className="text-sm text-[color:var(--ink-2)] mt-3">{p.excerpt}</p>
            <div className="flex items-center justify-between mt-6 text-xs text-[color:var(--ink-3)]">
              <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {p.readMinutes} min read · {new Date(p.date).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}</span>
              <span className="flex items-center gap-1 font-semibold text-[color:var(--emerald)]">Read <ArrowRight className="w-3.5 h-3.5" /></span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
